import { getEnum } from '@/api/common.js'
import {
  getExamIntroduction,
  getExamList,
  register,
  getExamCustom,
  setExamCustom,
  getStudentInfo,
  submitPersonInfo,
  checkedSigup
} from '../api/register.js'

const state = {
  examTypeEnum: [], // 考试类型
  examIntroduction: {}, //考试介绍
  examList: []
}
const mutations = {
  SET_EXAMTYPE: (state, value) => {
    state.examTypeEnum = value
  },
  SET_EXAMINTRODUCTION: (state, value) => {
    state.examIntroduction = value
  },
  SET_EXAMLIST: (state, value) => {
    state.examList = value
  }
}
const actions = {
  // 获取考试类型列表
  getExamTypeEnum({ commit }, params) {
    return getEnum(params).then(res => {
      commit('SET_EXAMTYPE', res)
    })
  },
  /* 获取考试介绍 */
  getExamIntroduction({ commit }, params) {
    return getExamIntroduction(params).then(res => {
      commit('SET_EXAMINTRODUCTION', res)
    })
  },
  // 获取考试列表
  getExamList({ commit }, params) {
    return getExamList(params).then(res => {
      commit('SET_EXAMLIST', res.list)
      return res
    })
  },
  /* 检查是否报名*/
  checkedSigup({ commit }, params) {
    return checkedSigup(params)
  },
  /* 考生填写好个人信息提交确定 */
  submitPersonInfo({ commit }, params) {
    return submitPersonInfo(params)
  },
  getExamCustom({ commit }, examId) {
    return getExamCustom(examId)
  },
  //报名时获取考生信息
  getStudentInfo({ commit }, userId) {
    return getStudentInfo(userId)
  },
  // 自定义考场
  setExamCustom({ commit }, params) {
    return setExamCustom(params)
  }
}
export default {
  state,
  mutations,
  actions
}
